var React = require('react');

function Delete (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M20 9v12c0 .53-.21 1.04-.586 1.414C19.04 22.79 18.53 23 18 23H6c-.53 0-1.04-.21-1.414-.586C4.21 22.04 4 21.53 4 21V9M1 5h22M8 5V1h8v4"}));
}

Delete.defaultProps = {"width":"24","height":"24","fill":"none","viewBox":"0 0 24 24","stroke":"#737680"};

module.exports = Delete;

Delete.default = Delete;
